import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'components/inputs/Select';
import * as Yup from 'yup';
import * as _ from 'lodash';
import { CREATE_STATE, UPDATE_STATE, FETCH_COUNTRY } from 'actions/address';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';

const StateSchema = Yup.object().shape({
  country: Yup.string().required('Country name is required'),
  name: Yup.string()
    .required('State name is required')
    .strict(true)
    .trim('Space is not allowed')
    .matches(/^[A-Za-z\s]+$/, 'Only alphabets are allowed')
    .max(100, 'Text limit should be less than 100 characters'),
  state_code: Yup.string()
    .required('State code is required')
    .strict(true)
    .trim('Space is not allowed')
    .matches(/^[A-Za-z]+$/, 'Only alphabets are allowed')
    .max(15, 'State code length should be less than 15 digits'),
});

const StateForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();

  const stateDetail = useSelector((state) => state.state.stateDetail);
  const allCountries = useSelector((state) => state.country.countries);
  const isLoading = useSelector((state) => state.state.isLoading);
  const countryPage = useSelector((state) => state.country.page);
  const countryTotalPage = useSelector((state) => state.country.totalPages);

  const addState = useCallback((data) => {
    dispatch({
      type: CREATE_STATE,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateState = useCallback((data) => {
    dispatch({
      type: UPDATE_STATE,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const getAllCountry = useCallback((data = {}) => {
    dispatch({ type: FETCH_COUNTRY, payload: data });
  }, []);

  useEffect(() => {
    getAllCountry();
  }, []);

  const initialValues = isEdit
    ? { ...stateDetail, country: _.get(stateDetail, 'country.id', '') }
    : {
        name: '',
        state_code: '',
        country: '',
      };
  return (
    <React.Fragment>
      <div className="state-form-page__main">
        <Card>
          <div className="state-form-header__block">
            <div className="state-header-name">
              <span>{isEdit ? 'Edit' : 'Add'} State</span>
            </div>
            <div className="close-btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
          </div>
          <div className="state-form-body__block">
            <div className="state-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={StateSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    updateState(values);
                  } else {
                    addState(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, setFieldValue, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg={12}>
                        <Select
                          isRequired
                          label="Country Name"
                          options={_.map(allCountries, (item) => {
                            return { label: item.name, value: item.id };
                          })}
                          placeholder="Select country name"
                          onMenuScrollDown={true}
                          getDataOnScrollDown={getAllCountry}
                          page={countryPage}
                          totalPage={countryTotalPage}
                          name="country"
                          value={_.get(values, 'country')}
                          onChange={(val) => setFieldValue(`country`, val)}
                          error={errors.country && touched.country ? errors.country : null}
                        />
                      </Col>
                      <Col lg={6}>
                        <TextInput
                          isRequired
                          label="State Name"
                          placeholder="State name"
                          name="name"
                          value={_.get(values, 'name')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                      <Col lg={6}>
                        <TextInput
                          isRequired
                          label="State Code"
                          placeholder="State code"
                          name="state_code"
                          value={_.get(values, 'state_code')}
                          onChange={handleChange}
                          error={errors.state_code && touched.state_code ? errors.state_code : null}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn-block">
                      <Button className="state-form-btn cancel_btn" onClick={onClose}>
                        Cancel
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="state-form-btn create-btn">
                        {isEdit ? 'Update' : 'Create'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
StateForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default StateForm;
